import { z } from 'zod';
import { SubscriptionsServiceType } from '../customer/SubscriptionsServiceType';

export type NotifyMeData = {
    email: string;
    subscriptionsServiceType: SubscriptionsServiceType;
    productIds: { productId: string }[];
};
export type NotifyMeState = {
    data: NotifyMeData;
    errors:
        | 'label.errorHasSubscribe'
        | 'label.email.errorEmpty'
        | 'label.email.errorInvalid'
        | 'error.defaultError'
        | undefined;
    success: boolean;
};

export enum NotifyMeField {
    Email = 'email',
    SubscriptionsServiceType = 'subscriptionsServiceType',
    ProductIds = 'productIds',
}

export const FormDataSchema = z.object({
    email: z.string().nonempty('label.email.errorEmpty').email('label.email.errorInvalid'),
    subscriptionsServiceType: z.enum([SubscriptionsServiceType.NEWSLETTER, SubscriptionsServiceType.BACKTOSTORE]),
    productIds: z.string().transform((value) => value?.split(',').map((id) => ({ productId: id }))),
});
